/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { Fragment, useState, useContext, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { DialogBox } from '@mummssoftware/common-ui';
import {
  GlobalContext,
  SET_LEVEL_OF_CARE,
  openVisit,
  attemptedVisit,
} from '@mummssoftware/global-context/GlobalContext';
import { formatDateMMDDYY } from '@mummssoftware/utils/formatters';
import { isAgencyEnabled } from '@mummssoftware/utils/utils';
import { GIPQCODES, emptyOption } from '@mummssoftware/utils/constants';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { find } from 'lodash-es';
import { Button } from '@material-ui/core';
import { VisitsGlobalContext } from '@mummssoftware/global-context/VisitsGlobalContext';
import {
  SET_ACTING_AS_ROLE,
  OPEN_VISIT_WIDGET,
  OptionType,
  GET_ROLE_GROUPS,
  SET_IPU_VISIT,
  InProgressDriving,
} from '../Context/constants';
import { VisitButton } from './VisitButton';
import {
  MultiRolesDiv,
  TextDiv,
  VisitButtonDivCenter,
  AppVisitCenter,
} from '../../components';
import { VisitContext } from '../Context/contexts/VisitContext';
import { DashboardContext } from '../Context/contexts/DashboardContext';
import { Context } from '../../context';
import defaults from '../../translations/en.json';

type VisitItemMenu = { text: string; id: string };

const useStyles = makeStyles((theme: Theme) => ({
  menuPaper: {
    width: 290,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
    overflow: 'visible',
  },
  visitPaper: {
    height: 'auto',
    width: 'auto',
    backgroundColor: `${(theme as any).palette.background.dark1}`,
    overflowX: 'hidden',
  },
  circular: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },
  radioGroup: {
    marginTop: '10px',
  },
  radio: {},
}));

export const VisitMenu = () => {
  const classes = useStyles();
  const { levelOfCare, appVisit } = useContext(GlobalContext);
  const globalContext = useContext(GlobalContext);
  const { globalDrivingVisit } = useContext(VisitsGlobalContext);
  const { patient, currentUser, isMummsAdmin } = useContext(Context);
  const { dispatchVisit, primaryRole, roleGroups, actingAsRole } = useContext(
    VisitContext,
  );
  const { dashboardReady } = useContext(DashboardContext);
  // only show visit for enabled agencies
  const enabledVisitBins: string = window.env?.enabledVisitBins as string;
  const isSelectedAgency = isAgencyEnabled(enabledVisitBins, currentUser);
  const findIPU = () => GIPQCODES.includes(patient?.currentFacilityQcode || '');

  const isPatientIPU = findIPU();

  const visitsNames: VisitItemMenu[] = [
    {
      text: defaults.openVisit,
      id: openVisit,
    },
    {
      text: defaults.attemptedVisit,
      id: attemptedVisit,
    },
  ];

  useEffect(() => {
    dispatchVisit({
      type: GET_ROLE_GROUPS,
      payload: true,
    });
  }, []);

  useEffect(() => {
    if (visitType) {
      setVisitType(null);
    }
    if (levelOfCare === null) {
      dispatchVisit({
        type: OPEN_VISIT_WIDGET,
        payload: false,
      });
    }
  }, [levelOfCare]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [visitType, setVisitType] = useState<string | null>(null);

  const onOpen = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const onClose = () => {
    setVisitType(null);
    setAnchorEl(null);
    if (!appVisit) {
      globalContext.dispatch({
        type: SET_LEVEL_OF_CARE,
        payload: null,
      });
    }
  };

  const [openRoleDialog, setOpenRoleDialog] = useState<boolean>(false);
  const [roleTypeRadios, setRoleTypeRadios] = useState<OptionType>(
    find(roleGroups, {
      rolegroup: actingAsRole || primaryRole,
    }) || emptyOption,
  );

  useEffect(() => {
    if (primaryRole && roleGroups) {
      const role = find(roleGroups, {
        rolegroup: primaryRole,
      });
      setRoleTypeRadios(role || emptyOption);
    }
  }, [primaryRole, roleGroups && roleGroups.length]);

  const onRoleTypeRadioChange = (role: any) => {
    setRoleTypeRadios(role);
    dispatchVisit({
      type: SET_ACTING_AS_ROLE,
      payload: role.target.value,
    });
  };

  const handleRoleDialog = () => {
    setOpenRoleDialog(false);
    handleAction();
  };

  const onCancelRolesDialog = () => {
    setVisitType(null);
    setOpenRoleDialog(false);
  };

  function sortValue(a: any, b: any) {
    const nameA = a.label.toUpperCase();
    const nameB = b.label.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }

  // getTitle and AppVisitText functions
  const appVisitText =
    appVisit &&
    `${appVisit.levelofcare} on ${formatDateMMDDYY(
      appVisit.effectivedatetime,
    )}`;

  const titleMap: any = {
    [openVisit]: 'creatingVisit',
  };

  const getTitle = () => {
    if (levelOfCare) {
      if (appVisit) {
        return defaults.recording;
      }
      return (defaults as any)[titleMap[levelOfCare]];
    }
    return false;
  };

  const setLevelOfCare = (visit: VisitItemMenu) => () => {
    setVisitType(visit.id);
  };

  useEffect(() => {
    visitType && handleAction();
  }, [visitType]); // trigger when visit is selected

  const handleAction = () => {
    globalContext.dispatch({
      type: SET_LEVEL_OF_CARE,
      payload: visitType,
    });
    dispatchVisit({
      type: OPEN_VISIT_WIDGET,
      payload: true,
    });
    setAnchorEl(null);
  };

  const openIPUVisit = () => {
    dispatchVisit({
      type: SET_IPU_VISIT,
      payload: true,
    });
    dispatchVisit({
      type: OPEN_VISIT_WIDGET,
      payload: true,
    });
  };

  const visitClass = {
    elevation8: classes.menuPaper,
  };
  const dialogClass = {
    root: classes.visitPaper,
  };
  // showVisitIcon is not an admin
  const showVisitIcon = !isMummsAdmin;
  const showIcon = showVisitIcon && isSelectedAgency;
  const drivingVisitActive = globalDrivingVisit?.status === InProgressDriving;

  return showIcon ? (
    <Fragment>
      <VisitButton
        onClick={onOpen}
        disabled={!dashboardReady || drivingVisitActive}
      />
      {isPatientIPU && (
        <VisitButton
          IPUButton
          onClick={openIPUVisit}
          disabled={!dashboardReady}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        PaperProps={{
          classes: visitClass,
        }}
      >
        {!levelOfCare &&
          !appVisit &&
          (visitsNames as any).map((item: VisitItemMenu, i: number) => (
            <MenuItem key={`item-${i}`} onClick={setLevelOfCare(item)}>
              {item.text}
            </MenuItem>
          ))}
        {appVisit && (
          <AppVisitCenter>
            <TextDiv>{getTitle()}</TextDiv>
            <div>{appVisitText}</div>
          </AppVisitCenter>
        )}
        <DialogBox
          title={defaults.actingAsRole} // defaults.multiRole
          draggable={false}
          disableBackdropClick
          open={openRoleDialog}
          handleClick={handleRoleDialog}
          PaperProps={{
            classes: dialogClass,
          }}
        >
          <MultiRolesDiv>
            {defaults.selectRoles}
            <RadioGroup
              aria-label="multi-role"
              name="multi-role"
              value={roleTypeRadios}
              onChange={onRoleTypeRadioChange}
              classes={{
                root: classes.radioGroup,
              }}
            >
              {roleGroups &&
                roleGroups.length &&
                roleGroups.sort(sortValue).map((item: any, d: number) => {
                  if (item !== null) {
                    return (
                      <FormControlLabel
                        key={d}
                        value={item.value}
                        control={
                          <Radio
                            color="primary"
                            checked={
                              item.value === (actingAsRole || primaryRole)
                            }
                            classes={{
                              root: classes.radio,
                            }}
                          />
                        }
                        label={item.label}
                      />
                    );
                  }
                  return false;
                })}
            </RadioGroup>
          </MultiRolesDiv>
          <VisitButtonDivCenter>
            <Button
              size="small"
              fullWidth
              variant="contained"
              color="default"
              onClick={onCancelRolesDialog}
            >
              {defaults.cancel}
            </Button>
          </VisitButtonDivCenter>
        </DialogBox>
      </Menu>
    </Fragment>
  ) : null;
};
export default VisitMenu;
